import { createContext, useContext, useState } from 'react';

const ReportAttendanceHostDetailContext = createContext();

const initialState = {
  isOpenImagePreview: false,
  selectedImagePreview: [],
  isOpenModalDetailLivestream: false,
  livestreamData: null,
  imagePreviewPreviousModal: null,
};

const initialFilterState = {
  page: 1,
  limit: 10,
  startedAt: null,
  endedAt: null,
  status: null,
};

const ReportAttendanceHostDetailProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return (
    <ReportAttendanceHostDetailContext.Provider value={{ updateState, state, updateFilterState, filterState }}>
      {children}
    </ReportAttendanceHostDetailContext.Provider>
  );
};

export const useReportAttendanceHostDetailState = () => {
  return useContext(ReportAttendanceHostDetailContext);
};

export default ReportAttendanceHostDetailProvider;
